import { render, staticRenderFns } from "./PersonalDetailForm.vue?vue&type=template&id=3efdf4c9"
import script from "./PersonalDetailForm.vue?vue&type=script&lang=js"
export * from "./PersonalDetailForm.vue?vue&type=script&lang=js"
import style0 from "./PersonalDetailForm.vue?vue&type=style&index=0&id=3efdf4c9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports